import { combineReducers } from 'redux';
import { s_wheel } from './wheel';
import { debugAllowed } from '../config';

const betsApp = combineReducers({
  s_wheel,
  debugAllowed: debugAllowed
});

export default betsApp;